export default "__VITE_ASSET__B9R6gwbC__"